module.exports = __webpack_public_path__ + "static/media/privacy-support.d6394fb2.png";